import { Zap } from "lucide-react";

export default function Navbar({ onNavigate }) {
  return (
    <header className="sticky top-0 z-50 border-b border-purple-900/30 bg-[#08040F]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 sm:px-8 lg:px-16">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display text-3xl leading-none tracking-wider text-white"
        >
          3x3 <span className="text-yellow-400">Basketball</span>
        </button>

        <div className="hidden items-center gap-2 font-mono-b3b text-[10px] uppercase tracking-[0.25em] text-slate-400 sm:flex">
          <span className="live-dot inline-block h-2 w-2 rounded-full bg-green-400" />
          Live bracket feed
        </div>

        <nav className="flex items-center gap-2 sm:gap-4">
          <button
            data-testid="nav-tournaments-link"
            onClick={() => onNavigate("tournaments")}
            className="rounded-full px-3 py-2 font-heading text-xs font-semibold uppercase tracking-widest text-slate-300 transition-colors hover:text-yellow-400 sm:px-4"
          >
            Tournaments
          </button>
          <button
            data-testid="nav-rules-link"
            onClick={() => onNavigate("rules")}
            className="hidden rounded-full px-3 py-2 font-heading text-xs font-semibold uppercase tracking-widest text-slate-300 transition-colors hover:text-yellow-400 sm:block sm:px-4"
          >
            Rules
          </button>
          <button
            data-testid="nav-register-cta"
            onClick={() => onNavigate("tournaments")}
            className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-4 py-2 font-heading text-xs font-bold uppercase tracking-widest text-black transition-transform hover:scale-105 active:scale-95"
          >
            <Zap className="h-3.5 w-3.5" /> Register
          </button>
        </nav>
      </div>
    </header>
  );
}
